import { render, staticRenderFns } from "./CollectChartletDetail.vue?vue&type=template&id=453c7c6c&scoped=true&"
import script from "./CollectChartletDetail.vue?vue&type=script&lang=js&"
export * from "./CollectChartletDetail.vue?vue&type=script&lang=js&"
import style0 from "./CollectChartletDetail.vue?vue&type=style&index=0&id=453c7c6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453c7c6c",
  null
  
)

export default component.exports